import axios from '@p/utils/request';
import api from '@/api';

//关于我们
export const getAboutus = () => {
	return axios.get(api.message.aboutus)
}

//最新消息
export const getLastNews = (data) => {
	return axios.get(api.message.getLastNews,{params:data})
}

// 消息详情
export const getNewsDetails = (data) => {
	return axios.get(api.message.getNewsDetails+'/'+data)
}